// Select the target node that contains the displayed price
const targetNode = document.querySelector('[data-product-price]');

// Options for the observer (which mutations to observe)
const config = { childList: true, subtree: true };

/*

// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
  for(const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Get the current displayed price
      const priceText = targetNode.textContent.trim().replace(/\s+/g, ' ');
      const matches = priceText.match(/\d{1,3}(,\d{3})*(\.\d+)?/);
      if (!matches) {
        return;
      }
      const displayedPrice = parseFloat(matches[0].replace(/,/g, ''));

      // Check if the price is less than or equal to 50
      if (displayedPrice <= 50) {
        // Adjust the price by adding 320
        const adjustedPrice = displayedPrice + 320;

        // Update the displayed price on the page
        targetNode.innerHTML = 'From HK$' + adjustedPrice.toFixed(0) + ' to HK$430';
      }
    }
  }
}

*/

// Create a new observer instance
const observer = new MutationObserver(callback);

// Start observing the target node for mutations
observer.observe(targetNode, config);
